/**
 * Pagination component overrides.
 * Pill-shaped pagination items with glow on selected.
 */

import type { Theme } from '@mui/material/styles';

const pagination: Theme['components'] = {
  MuiPagination: {
    styleOverrides: {
      root: {
        variants: [
          {
            props: { variant: 'text', color: 'primary' },
            style: {
              '& .MuiPaginationItem-root.Mui-selected': {
                boxShadow: '0 0 16px rgba(139, 92, 246, 0.25)',
              },
              '& .MuiPaginationItem-root.Mui-selected.Mui-disabled': {
                backgroundColor: 'var(--mui-palette-primary-main)',
                color: 'var(--mui-palette-primary-contrastText)',
              },
            },
          },
          {
            props: { variant: 'outlined', color: 'primary' },
            style: {
              '& .MuiPaginationItem-root.Mui-selected': {
                color: 'var(--mui-palette-primary-main)',
                backgroundColor: 'var(--mui-palette-primary-lightOpacity)',
                borderColor: 'rgb(var(--mui-palette-primary-mainChannel))',
              },
            },
          },
        ],
      },
      ul: {
        rowGap: 6,
      },
    },
  },
  MuiPaginationItem: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        borderRadius: 999,
        transition: 'all 150ms ease',
        ...(ownerState.size === 'medium' && {
          height: 36,
          minWidth: 36,
        }),
        '&.Mui-selected.Mui-disabled': {
          color: 'var(--mui-palette-text-primary)',
          opacity: 0.45,
        },
        '&.Mui-disabled': {
          opacity: 0.45,
        },
      }),
      ellipsis: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      sizeSmall: {
        height: 30,
        minWidth: 30,
      },
      sizeLarge: {
        height: 44,
        minWidth: 44,
      },
    },
  },
};

export default pagination;
